<template>
  <div>
    <div>
      <button type="button" class="btn btn-primary" v-if="!controlerBtnSubmit" @click="abrirModal()">Exportar Extra</button>
      <button type="button" class="btn btn-primary" disabled v-else><i class='fa fa-refresh fa-spin'></i> Carregando Extra Contratual...</button>
    </div>
    <modal-exportar-extra @selecionado="exportarExtra" />
  </div>
</template>

<script>
import modalExportarExtra from '../../modal/ExportarExtra.vue'

export default {
  data() {
    return {
      env: process.env,
      fechamentos: '',
      controlerBtnSubmit: false
    }
  },
  components: {
    'modal-exportar-extra': modalExportarExtra
  },
  methods: {
    abrirModal() {
      this.$store.commit('setModalExportarExtra', { show: true });
    },
    exportarExtra(ano) {
      this.controlerBtnSubmit = true

      let parametros = {
        estado: this.$store.state.login.loginUsuario.estado,
        ano: ano
      }
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/exportFechamentoExtraContratual`, parametros, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          let arquivoDownload = response.data.arquivo_download

          // Redirecionar a janela atual para o link de download.
          // Obs.: Remove o final 'api' do env.FINANCEIRO.SLA, pois, a rota é web.
          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload

          setTimeout(() => {
            vm.controlerBtnSubmit = false
          }, 10000)
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
          vm.controlerBtnSubmit = false
        }
      }).catch(() => {
        this.controlerBtnSubmit = false
      })
    }
  }
}
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    margin-right: 5px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
  } */
</style>



// WEBPACK FOOTER //
// ExportarFechamentoExtra.vue?62728cc7